var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-sm btn-secondary",attrs:{"disabled":!_vm.enabled},on:{"click":function($event){$event.preventDefault();return _vm.$emit("click")}}},[_c('fa-icon',{attrs:{"icon":_vm.icon}}),_vm._v("\n  "+_vm._s(_vm.label)+"\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }